import dayjs from 'dayjs';
import { services } from '@/shared/plugins/services';

const subscriber = services.resolve('subscriber');
export const dateFormatString = function () {
  switch (subscriber.currentLanguage.toUpperCase()) {
    case 'LT':
      return {
        short: 'MM.DD',
        long: 'YYYY.MM.DD',
        monthWithDate: 'MMM. DD | HH:mm',
      };
    default:
      return {
        short: 'DD.MM',
        long: 'DD.MM.YYYY',
        monthWithDate: 'MMM DD | HH:mm',
      };
  }
};

export default function dateFormat(date, format) {
  return dayjs(date).locale(subscriber.currentLanguage.toLowerCase()).format(format);
}

export function getFormatedLongDate(date) {
  return dayjs(date).locale(subscriber.currentLanguage.toLowerCase()).format(dateFormatString().long);
}

export function getFormatedShortDate(date) {
  return dayjs(date).locale(subscriber.currentLanguage.toLowerCase()).format(dateFormatString().short);
}

export function getFormatedMonthDateWithTime(date, secondDate) {
  const currentLanguage = subscriber.currentLanguage.toLowerCase();
  let stringDate = dayjs(date).locale(currentLanguage).format(dateFormatString().monthWithDate);

  if (secondDate) {
    stringDate += dayjs(secondDate).locale(currentLanguage).format(' - HH:mm');
  }

  if (currentLanguage === 'lt') {
    return stringDate[0].toUpperCase() + stringDate.slice(1);
  }

  return stringDate;
}
